module.exports = __webpack_public_path__ + "img/icon_parodontologie.30c03664.svg";